module.exports = __webpack_public_path__ + "img/affandi.e321e946.png";